'use client';

import React from 'react';
import clsx from 'clsx';
import styles from './RichContent.module.scss';
import Text from '@/components/Text/Text';

type RichContentProps = {
  data: {
    title: string;
    description?: string;
  };
  className?: string;
};

const RichContent = ({ data, className = '' }: RichContentProps) => (
  <section
    className={clsx(styles.richContent, className)}
  >
    <div className={clsx(styles.content)}>
      <div className={styles.textContainer}>
        <Text
          tag='h1'
          className={styles.title}
        >
          {data.title}
        </Text>
        {data?.description && (
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data.description,
            }}
          />
        )}
      </div>
    </div>
  </section>
);

export default RichContent;
